export const languages: { code: string; name: string; cc: string }[] = [
    { code: 'aa', name: 'Afar', cc: 'dj' },
    { code: 'ab', name: 'Abkhazian', cc: 'ge' },
    { code: 'ae', name: 'Avestan', cc: 'ir' },
    { code: 'af', name: 'Afrikaans', cc: 'za' },
    { code: 'ak', name: 'Akan', cc: 'gh' },
    { code: 'am', name: 'Amharic', cc: 'et' },
    { code: 'an', name: 'Aragonese', cc: 'es' },
    { code: 'ar', name: 'Arabic', cc: 'sa' },
    { code: 'as', name: 'Assamese', cc: 'in' },
    { code: 'av', name: 'Avaric', cc: 'az' },
    { code: 'ay', name: 'Aymara', cc: 'bo' },
    { code: 'az', name: 'Azerbaijani', cc: 'az' },
    { code: 'ba', name: 'Bashkir', cc: 'ru' },
    { code: 'be', name: 'Belarusian', cc: 'by' },
    { code: 'bg', name: 'Bulgarian', cc: 'bg' },
    { code: 'bh', name: 'Bihari languages', cc: 'in' },
    { code: 'bi', name: 'Bislama', cc: 'vu' },
    { code: 'bm', name: 'Bambara', cc: 'ml' },
    { code: 'bn', name: 'Bengali', cc: 'bd' },
    { code: 'bo', name: 'Tibetan', cc: 'cn' },
    { code: 'br', name: 'Breton', cc: 'fr' },
    { code: 'bs', name: 'Bosnian', cc: 'ba' },
    { code: 'ca', name: 'Catalan; Valencian', cc: 'es' },
    { code: 'ce', name: 'Chechen', cc: 'ru' },
    { code: 'ch', name: 'Chamorro', cc: 'us' },
    { code: 'co', name: 'Corsican', cc: 'fr' },
    { code: 'cr', name: 'Cree', cc: 'us' },
    { code: 'cs', name: 'Czech', cc: 'cz' },
    { code: 'cu', name: 'Church Slavic', cc: 'bg' },
    { code: 'cv', name: 'Chuvash', cc: 'ru' },
    { code: 'cy', name: 'Welsh', cc: 'gb' },
    { code: 'da', name: 'Danish', cc: 'dk' },
    { code: 'de', name: 'German', cc: 'de' },
    { code: 'dv', name: 'Divehi; Dhivehi; Maldivian', cc: 'mv' },
    { code: 'dz', name: 'Dzongkha', cc: 'bt' },
    { code: 'ee', name: 'Ewe', cc: 'tg' },
    { code: 'el', name: 'Greek, Modern (1453-)', cc: 'gr' },
    { code: 'en', name: 'English', cc: 'gb' },
    { code: 'eo', name: 'Esperanto', cc: 'un' },
    { code: 'es', name: 'Spanish; Castilian', cc: 'es' },
    { code: 'et', name: 'Estonian', cc: 'ee' },
    { code: 'eu', name: 'Basque', cc: 'es' },
    { code: 'fa', name: 'Persian', cc: 'ir' },
    { code: 'ff', name: 'Fulah', cc: 'sn' },
    { code: 'fi', name: 'Finnish', cc: 'fi' },
    { code: 'fj', name: 'Fijian', cc: 'fj' },
    { code: 'fo', name: 'Faroese', cc: 'fo' },
    { code: 'fr', name: 'French', cc: 'fr' },
    { code: 'fy', name: 'Western Frisian', cc: 'nl' },
    { code: 'ga', name: 'Irish', cc: 'ie' },
    { code: 'gd', name: 'Gaelic; Scottish Gaelic', cc: 'gb' },
    { code: 'gl', name: 'Galician', cc: 'gb' },
    { code: 'gn', name: 'Guarani', cc: 'py' },
    { code: 'gu', name: 'Gujarati', cc: 'in' },
    { code: 'gv', name: 'Manx', cc: 'gb' },
    { code: 'ha', name: 'Hausa', cc: 'ng' },
    { code: 'he', name: 'Hebrew', cc: 'il' },
    { code: 'hi', name: 'Hindi', cc: 'in' },
    { code: 'ho', name: 'Hiri Motu', cc: 'pg' },
    { code: 'hr', name: 'Croatian', cc: 'hr' },
    { code: 'ht', name: 'Haitian; Haitian Creole', cc: 'ht' },
    { code: 'hu', name: 'Hungarian', cc: 'hu' },
    { code: 'hy', name: 'Armenian', cc: 'am' },
    { code: 'hz', name: 'Herero', cc: 'na' },
    { code: 'ia', name: 'Interlingua', cc: 'un' },
    { code: 'id', name: 'Indonesian', cc: 'id' },
    { code: 'ie', name: 'Interlingue; Occidental', cc: 'un' },
    { code: 'ig', name: 'Igbo', cc: 'ng' },
    { code: 'ii', name: 'Sichuan Yi; Nuosu', cc: 'cn' },
    { code: 'ik', name: 'Inupiaq', cc: 'us' },
    { code: 'io', name: 'Ido', cc: 'un' },
    { code: 'is', name: 'Icelandic', cc: 'is' },
    { code: 'it', name: 'Italian', cc: 'it' },
    { code: 'iu', name: 'Inuktitut', cc: 'ca' },
    { code: 'ja', name: 'Japanese', cc: 'jp' },
    { code: 'jv', name: 'Javanese', cc: 'id' },
    { code: 'ka', name: 'Georgian', cc: 'ge' },
    { code: 'kg', name: 'Kongo', cc: 'cd' },
    { code: 'ki', name: 'Kikuyu; Gikuyu', cc: 'ke' },
    { code: 'kj', name: 'Kuanyama; Kwanyama', cc: 'ao' },
    { code: 'kk', name: 'Kazakh', cc: 'kz' },
    { code: 'kl', name: 'Kalaallisut; Greenlandic', cc: 'gl' },
    { code: 'km', name: 'Central Khmer', cc: 'kh' },
    { code: 'kn', name: 'Kannada', cc: 'in' },
    { code: 'ko', name: 'Korean', cc: 'kr' },
    { code: 'kr', name: 'Kanuri', cc: 'ng' },
    { code: 'ks', name: 'Kashmiri', cc: 'in' },
    { code: 'ku', name: 'Kurdish', cc: 'un' },
    { code: 'kv', name: 'Komi', cc: 'ru' },
    { code: 'kw', name: 'Cornish', cc: 'gb' },
    { code: 'ky', name: 'Kirghiz; Kyrgyz', cc: 'kg' },
    { code: 'la', name: 'Latin', cc: 'va' },
    { code: 'lb', name: 'Luxembourgish; Letzeburgesch', cc: 'lu' },
    { code: 'lg', name: 'Ganda', cc: 'ao' },
    { code: 'li', name: 'Limburgan; Limburger; Limburgish', cc: 'nl' },
    { code: 'ln', name: 'Lingala', cc: 'cd' },
    { code: 'lo', name: 'Lao', cc: 'la' },
    { code: 'lt', name: 'Lithuanian', cc: 'lt' },
    { code: 'lu', name: 'Luba-Katanga', cc: 'cd' },
    { code: 'lv', name: 'Latvian', cc: 'lv' },
    { code: 'mg', name: 'Malagasy', cc: 'mg' },
    { code: 'mh', name: 'Marshallese', cc: 'mh' },
    { code: 'mi', name: 'Maori', cc: 'nz' },
    { code: 'mk', name: 'Macedonian', cc: 'mk' },
    { code: 'ml', name: 'Malayalam', cc: 'in' },
    { code: 'mn', name: 'Mongolian', cc: 'mn' },
    { code: 'mr', name: 'Marathi', cc: 'in' },
    { code: 'ms', name: 'Malay', cc: 'id' },
    { code: 'mt', name: 'Maltese', cc: 'mt' },
    { code: 'my', name: 'Burmese', cc: 'mm' },
    { code: 'na', name: 'Nauru', cc: 'nr' },
    { code: 'nb', name: 'Norwegian Bokmål', cc: 'no' },
    { code: 'nd', name: 'Ndebele, North; North Ndebele', cc: 'za' },
    { code: 'ne', name: 'Nepali', cc: 'np' },
    { code: 'ng', name: 'Ndonga', cc: 'na' },
    { code: 'nl', name: 'Dutch; Flemish', cc: 'nl' },
    { code: 'nn', name: 'Norwegian Nynorsk', cc: 'no' },
    { code: 'no', name: 'Norwegian', cc: 'no' },
    { code: 'nr', name: 'Ndebele, South; South Ndebele', cc: 'za' },
    { code: 'nv', name: 'Navajo; Navaho', cc: 'mx' },
    { code: 'ny', name: 'Chichewa; Chewa; Nyanja', cc: 'mw' },
    { code: 'oc', name: 'Occitan (post 1500)', cc: 'es' },
    { code: 'oj', name: 'Ojibwa', cc: 'ca' },
    { code: 'om', name: 'Oromo', cc: 'et' },
    { code: 'or', name: 'Oriya', cc: 'in' },
    { code: 'os', name: 'Ossetian; Ossetic', cc: 'ru' },
    { code: 'pa', name: 'Panjabi; Punjabi', cc: 'in' },
    { code: 'pi', name: 'Pali', cc: 'in' },
    { code: 'pl', name: 'Polish', cc: 'pl' },
    { code: 'ps', name: 'Pushto; Pashto', cc: 'af' },
    { code: 'pt', name: 'Portuguese', cc: 'pt' },
    { code: 'qu', name: 'Quechua', cc: 'pe' },
    { code: 'rm', name: 'Romansh', cc: 'ch' },
    { code: 'rn', name: 'Rundi', cc: 'bi' },
    { code: 'ro', name: 'Romanian; Moldavian; Moldovan', cc: 'ro' },
    { code: 'ru', name: 'Russian', cc: 'ru' },
    { code: 'rw', name: 'Kinyarwanda', cc: 'rw' },
    { code: 'sa', name: 'Sanskrit', cc: 'un' },
    { code: 'sc', name: 'Sardinian', cc: 'it' },
    { code: 'sd', name: 'Sindhi', cc: 'pk' },
    { code: 'se', name: 'Northern Sami', cc: 'no' },
    { code: 'sg', name: 'Sango', cc: 'cf' },
    { code: 'si', name: 'Sinhala; Sinhalese', cc: 'lk' },
    { code: 'sk', name: 'Slovak', cc: 'sk' },
    { code: 'sl', name: 'Slovenian', cc: 'si' },
    { code: 'sm', name: 'Samoan', cc: 'ws' },
    { code: 'sn', name: 'Shona', cc: 'za' },
    { code: 'so', name: 'Somali', cc: 'so' },
    { code: 'sq', name: 'Albanian', cc: 'al' },
    { code: 'sr', name: 'Serbian', cc: 'rs' },
    { code: 'ss', name: 'Swati', cc: 'za' },
    { code: 'st', name: 'Sotho, Southern', cc: 'ls' },
    { code: 'su', name: 'Sundanese', cc: 'id' },
    { code: 'sv', name: 'Swedish', cc: 'se' },
    { code: 'sw', name: 'Swahili', cc: 'ke' },
    { code: 'ta', name: 'Tamil', cc: 'in' },
    { code: 'te', name: 'Telugu', cc: 'in' },
    { code: 'tg', name: 'Tajik', cc: 'tj' },
    { code: 'th', name: 'Thai', cc: 'th' },
    { code: 'ti', name: 'Tigrinya', cc: 'er' },
    { code: 'tk', name: 'Turkmen', cc: 'tm' },
    { code: 'tl', name: 'Tagalog', cc: 'ph' },
    { code: 'tn', name: 'Tswana', cc: 'bw' },
    { code: 'to', name: 'Tonga (Tonga Islands)', cc: 'to' },
    { code: 'tr', name: 'Turkish', cc: 'tr' },
    { code: 'ts', name: 'Tsonga', cc: 'za' },
    { code: 'tt', name: 'Tatar', cc: 'ru' },
    { code: 'tw', name: 'Twi', cc: 'gh' },
    { code: 'ty', name: 'Tahitian', cc: 'pf' },
    { code: 'ug', name: 'Uighur; Uyghur', cc: 'cn' },
    { code: 'uk', name: 'Ukrainian', cc: 'ua' },
    { code: 'ur', name: 'Urdu', cc: 'pk' },
    { code: 'uz', name: 'Uzbek', cc: 'uz' },
    { code: 've', name: 'Venda', cc: 'za' },
    { code: 'vi', name: 'Vietnamese', cc: 'vn' },
    { code: 'vo', name: 'Volapük', cc: 'un' },
    { code: 'wa', name: 'Walloon', cc: 'be' },
    { code: 'wo', name: 'Wolof', cc: 'sn' },
    { code: 'xh', name: 'Xhosa', cc: 'za' },
    { code: 'yi', name: 'Yiddish', cc: 'un' },
    { code: 'yo', name: 'Yoruba', cc: 'ng' },
    { code: 'za', name: 'Zhuang; Chuang', cc: 'cn' },
    { code: 'zh', name: 'Chinese', cc: 'cn' },
    { code: 'zu', name: 'Zulu', cc: 'za' }
];
